import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import { Divider, Paper } from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import { connect } from "react-redux";
import Axios from "axios";

import NavBar from "../../../../Component/NavBar/AdminHeader/AdminHeader";
import { url } from "../../../../config/config";

const drawerWidth = 240;

const useStyles = (theme) => ({
  root: {
    marginLeft: drawerWidth,
    minHeight: "100vh",
    padding: 30,
    marginTop: 50,
    backgroundColor: "#f9f9fc",
    [theme.breakpoints.down("sm")]: {
      marginLeft: "auto",
      marginRight: "auto",
      padding: 20,
    },
  },
});

class EditMessage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        message: "",
        authorId: "",
        bookId: "",
      },
      authorName: "",
      messageId: "",
    };
  }

  async componentDidMount() {
    const response = await Axios.get(
      `${url}/api/messages/${this.props.match.params.messageId}`,
      {
        headers: {
          "x-auth-token": this.props.adminToken,
        },
      }
    );
    if (response.data.message.length !== 0) {
      this.setState({
        authorName:
          response.data.message.authorId.firstName +
          " " +
          response.data.message.authorId.middleName +
          " " +
          response.data.message.authorId.lastName,
        messageId: response.data.message._id,
        data: {
          ...this.state.data,
          message: response.data.message.message,
          authorId: response.data.message.authorId._id,
          bookId: response.data.message.bookId._id,
        },
      });
    }
  }

  handleChange = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        [e.target.name]: e.target.value,
      },
    });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const response = await Axios.put(
      `${url}/api/messages/${this.state.messageId}`,
      this.state.data,
      {
        headers: {
          "x-auth-token": this.props.adminToken,
        },
      }
    );
    if (response.data.message) {
      this.props.history.push("/_administration_/books/unapproved");
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <div>
        <NavBar />
        <div className={classes.root}>
          <div style={{ fontSize: 25 }}>Edit Message</div>
          <Divider />
          <br />
          <Paper>
            <form onSubmit={this.handleSubmit} style={{ padding: 30 }}>
              <TextField
                name="authorName"
                type="text"
                label="Author Name"
                fullWidth
                required
                disabled
                margin="normal"
                variant="outlined"
                style={{ outline: "none" }}
                InputProps={{
                  classes: {
                    root: classes.inputRoot,
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.authorName}
              />

              <TextField
                name="message"
                type="string"
                label="Message"
                fullWidth
                required
                multiline
                rows={4}
                rowsMax={8}
                margin="normal"
                variant="outlined"
                style={{ outline: "none" }}
                error={this.state.messageError ? true : false}
                helperText={this.state.messageError}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.message}
                onChange={this.handleChange}
              />

              <div style={{ display: "flex", justifyContent: "center" }}>
                <Button type="submit" className={classes.buttonStyle}>
                  Submit
                </Button>
              </div>
            </form>
          </Paper>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
  };
};

export default connect(
  mapStateToProps,
  null
)(withStyles(useStyles)(withRouter(EditMessage)));
